import { render, staticRenderFns } from "./contract-payment.html?vue&type=template&id=22b793bc&scoped=true&external"
import script from "./contract-payment.js?vue&type=script&lang=js&external"
export * from "./contract-payment.js?vue&type=script&lang=js&external"
import style0 from "./contract-payment.scss?vue&type=style&index=0&id=22b793bc&prod&lang=scss&scoped=true&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b793bc",
  null
  
)

export default component.exports